/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * type of estimated usage
 */
export type EstimatedUsageType =
  (typeof EstimatedUsageType)[keyof typeof EstimatedUsageType]

export const EstimatedUsageType = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  EV_OWNER: "EV_OWNER",
  EXACT_AMOUNT: "EXACT_AMOUNT",
} as const
